import { InjectionToken } from '@angular/core';

/**
 * Means we can inject 0 debounce time for testing
 */
export const FORM_DEBOUNCE_TIME_MS = new InjectionToken<number>(
  'Form debounce time in milliseconds'
);
